import { DiffTab } from '@/store/helpers/diffHelpers';

export interface DiffModeState {
  active: boolean;
  tabs: DiffTab[];
  insertCount: number;
  deleteCount: number;
  fromVersion: number | null;
  articleId: string | null;
}

export interface SetDiffStatePayload {
  tabs: DiffTab[];
  insertCount: number;
  deleteCount: number;
  fromVersion: number;
  articleId: string;
}

export function createInitialDiffState(): DiffModeState {
  return {
    active: false,
    tabs: [],
    insertCount: 0,
    deleteCount: 0,
    fromVersion: null,
    articleId: null,
  };
}

export const diffMutations = {
  setDiffState(state: { diffMode: DiffModeState }, payload: SetDiffStatePayload) {
    state.diffMode.active = true;
    state.diffMode.tabs = payload.tabs;
    state.diffMode.insertCount = payload.insertCount;
    state.diffMode.deleteCount = payload.deleteCount;
    state.diffMode.fromVersion = payload.fromVersion;
    state.diffMode.articleId = payload.articleId;
  },

  clearDiffState(state: { diffMode: DiffModeState }) {
    state.diffMode.active = false;
    state.diffMode.tabs = [];
    state.diffMode.insertCount = 0;
    state.diffMode.deleteCount = 0;
    state.diffMode.fromVersion = null;
    state.diffMode.articleId = null;
  },
};
